module.exports = __webpack_public_path__ + "img/loading.d83212c1.gif";